import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { JsonLDV2 } from '~/routes/discover.$keyword/head/json-ld/Item-list';
import { $UserAgent } from '@lemon8/web-app-shared/atom';
import { CollectionPageJsonLD } from './collection-page';

export const JsonLD: FC = () => {
  const { isBot } = useAtomValue($UserAgent);

  return (
    <>
      {isBot && (
        <>
          <JsonLDV2 />
          <CollectionPageJsonLD />
        </>
      )}
    </>
  );
};
